import { rgba } from 'polished';
import { index, Options } from 'shared/assets/styles';
import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  border-radius: ${({ theme }) => theme.spacing(4)};
  background: ${({ theme }) => theme.palette.background.default};
  overflow: hidden;
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  // the locked content keeps its own stacking (the timeline's sticky sidebar sits at TOPBAR)
  z-index: ${index(Options.PREMIUM_OVERLAY)};

  display: flex;
  align-items: center;
  justify-content: center;

  padding: ${({ theme }) => theme.spacing(6)};

  background: rgba(0, 0, 0, 0.2);
`;

export const Dialog = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(6)};

  margin: ${({ theme }) => theme.spacing(6)};
  padding: ${({ theme }) => `${theme.spacing(6)} ${theme.spacing(10)}`};
  max-width: 44rem;

  background: ${({ theme }) => rgba(theme.palette.background.paper, 0.85)};
  border-radius: ${({ theme }) => theme.spacing(5)};
  box-shadow: ${({ theme }) => theme.shadowBox.dialog};
  backdrop-filter: blur(24px);

  text-align: center;
`;

export const DialogContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1.5)};
`;
